import axios from 'axios';

const widgetHelper = require('@/scripts/widgetHelper');

const clearMap = (markers) => {
    Object.keys(markers).forEach((key) => {
        markers[key].marker.setMap(null);
    });
};

const activateMarker = (marker, pickupPointID, state) => {
    if (state.activeMarker) {
        const icon = state.activeMarker.getIcon();
        icon.scaledSize = new google.maps.Size(35, 35);
        state.activeMarker.setIcon(icon);
    }

    state.map.panTo(marker.getPosition()); // eslint-disable-line
    var currentZoom = state.map.getZoom();
    if (currentZoom < 13) {
        state.map.setZoom(13);
    }
    marker.setIcon({
        url: `${window.vue.variables.staticImagesFolder}/location_1.svg`,
        scaledSize: new google.maps.Size(50, 50)
    });
    state.activeMarker = marker;

    const activePickupPoint = state.pickupPoints.find((item) => item.identifiant === pickupPointID);

    state.activePickupPoint = {
        id: activePickupPoint.identifiant,
        name: activePickupPoint.nom,
        type: activePickupPoint.typeDePoint,
        address1: activePickupPoint.adresse1,
        address2: activePickupPoint.adresse2,
        city: activePickupPoint.localite,
        postalCode: activePickupPoint.codePostal
    };
};

const getMarker = (pickupPoint, state) => {
    const marker = new google.maps.Marker({
        position: {
            lat: Number(pickupPoint.coordGeolocalisationLatitude),
            lng: Number(pickupPoint.coordGeolocalisationLongitude)
        },
        map: state.map,
        icon: {
            url: `${window.vue.variables.staticImagesFolder}/location_1.svg`,
            scaledSize: new google.maps.Size(35, 35)
        },
        title: pickupPoint.nom
    });

    marker.setMap(state.map);
    return marker;
};

export default {
    state: {
        pickupPoints: {},
        mapMarkers: [],
        activeMarker: null,
        activePickupPoint: '',
        map: null
    },
    getters: {
        pickupPoints(state) {
            return state.pickupPoints;
        },
        mapMarkers(state) {
            return state.mapMarkers;
        },
        activePickupPoint(state) {
            return state.activePickupPoint;
        },
        map(state) {
            return state.map;
        }
    },
    mutations: {
        setPickupPoints(state, data) {
            state.pickupPoints = data;
        },
        setMarkers(state, markers) {
            state.mapMarkers = markers;
            widgetHelper.spinner.stop();
        },
        setActiveMarker(state, pickupPointID) {
            activateMarker(state.mapMarkers[pickupPointID].marker, pickupPointID, state);
        },
        setMap(state, data) {
            state.map = data;
        }
    },
    actions: {
        getPickupPoints({ commit, state, rootState }) {
            const data = {
                country: rootState.forms.formFields.shipping.country,
                zipCode: rootState.forms.formFields.shipping.postalCode,
                csrf_token: document.querySelector('.shipping-form').querySelector('[name="csrf_token"]').value
            };
            widgetHelper.spinner.start();
            const apiString = `${rootState.actionURLs['Checkout-GetPickupPoints']}`;
            return axios.get(apiString, { params: data })
                .then((responseData) => {
                    const pickupPoints = responseData.data.pickupPoints;

                    if (!pickupPoints || pickupPoints.length === 0) {
                        document.getElementsByClassName('pickup-error')[0].classList.remove('d-none');
                    } else {
                        document.getElementsByClassName('pickup-error')[0].classList.add('d-none');
                    }

                    commit('setPickupPoints', pickupPoints);
                    clearMap(state.mapMarkers);

                    const markers = {};
                    pickupPoints.forEach((pickupPoint) => {
                        const marker = getMarker(pickupPoint, state);
                        marker.addListener('click', () => {
                            const pickupPointNode = document.getElementById(`pickup-${pickupPoint.identifiant}`);
                            const pickupPointContainer = pickupPointNode.closest('.pickup-point-block-container');
                            pickupPointContainer.scrollTo({
                                top: pickupPointNode.closest('.pickup-point-block').offsetTop,
                                behavior: 'smooth'
                            });
                            commit('setActiveMarker', pickupPoint.identifiant);
                        });
                        markers[pickupPoint.identifiant] = {
                            marker
                        };
                    });
                    if (pickupPoints.length > 0) {
                        state.map.panTo(markers[pickupPoints[0].identifiant].marker.getPosition()); // eslint-disable-line
                        const currentZoom = state.map.getZoom();
                        if (currentZoom < 11) {
                            state.map.setZoom(11);
                        }
                    }

                    commit('setMarkers', markers);
                })
                .catch((error) => {
                    if (error.response.data.redirectUrl) {
                        window.location.href = error.response.data.redirectUrl;
                    }
                    widgetHelper.spinner.stop();
                });
        },
        // eslint-disable-next-line no-unused-vars
        setActiveMarker({ commit, state }, pickupPointID) {
            commit('setActiveMarker', pickupPointID);
        },
        setMap({ commit }, payload) {
            commit('setMap', payload);
        }
    }
};
